export default "/dist/files/choix_animation_grattage.92ddcda9be2834016b3fc67b3ea25ed4.svg";